<div style="padding: 25px">
  <div class="flex justify-between items-center gap-3">
    <span class="text-black font-black uppercase">Perfil</span>

    <button *isAllowed="[ERoleAdminString.Admin, 'role.export']" class="px-5 min-w-max btn btn--primary h-35"
      (click)="downloadExcel()">
      <img class="w-6 h-6" src="assets/icons/download.svg" alt="Download Excel" />
    </button>
  </div>

  <app-list-roles></app-list-roles>
  <hr class="mb-8" />
  <app-add-new-role></app-add-new-role>
  <hr class="my-8" *isAllowed="[ERoleAdminString.Admin, 'role.create']" />
</div>